// Mock data for Primeswift Solutions website

export const services = [
  {
    id: 1,
    title: "Freight & Transportation",
    description: "Reliable freight services across the country with real-time tracking and on-time delivery guarantee.",
    icon: "Truck",
    features: ["Door-to-door delivery", "Real-time tracking", "24/7 support"]
  },
  {
    id: 2,
    title: "Warehousing & Storage",
    description: "Secure and spacious warehousing solutions with advanced inventory management systems.",
    icon: "Warehouse",
    features: ["Climate controlled", "24/7 security", "Inventory management"]
  },
  {
    id: 3,
    title: "Last-Mile Delivery",
    description: "Fast and efficient last-mile delivery ensuring your products reach customers on time.",
    icon: "Package",
    features: ["Same-day delivery", "Express options", "Proof of delivery"]
  },
  {
    id: 4,
    title: "Supply Chain Management",
    description: "End-to-end supply chain solutions optimized for efficiency and cost-effectiveness.",
    icon: "Network",
    features: ["Route optimization", "Cost reduction", "Performance analytics"]
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Pan-India Network",
    description: "Extensive network covering major cities and remote locations across India",
    icon: "MapPin"
  },
  {
    id: 2,
    title: "Real-Time Tracking",
    description: "Track your shipments in real-time with our advanced GPS-enabled system",
    icon: "Navigation"
  },
  {
    id: 3,
    title: "24/7 Support",
    description: "Round-the-clock customer support to assist you at every step",
    icon: "Headphones"
  },
  {
    id: 4,
    title: "Flexible Solutions",
    description: "Customized logistics solutions tailored to your business needs",
    icon: "Settings"
  }
];

export const vehicleTypes = [
  { value: "two-wheeler", label: "Two Wheeler" },
  { value: "three-wheeler", label: "Three Wheeler" },
  { value: "tata-ace", label: "Tata Ace / Mini Truck (1 Ton)" },
  { value: "pickup", label: "Pickup Truck (2-3 Ton)" },
  { value: "light-truck", label: "Light Commercial Vehicle (5-7 Ton)" },
  { value: "medium-truck", label: "Medium Truck (10-15 Ton)" },
  { value: "heavy-truck", label: "Heavy Truck (15-25 Ton)" },
  { value: "trailer", label: "Trailer / Container (25+ Ton)" },
  { value: "tempo", label: "Tempo / Canter" },
  { value: "other", label: "Other" }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "",
    role: "Logistics Manager",
    content: "Primeswift has transformed our supply chain operations. Their reliability and real-time tracking have made our logistics seamless.",
    rating: 5
  },
  {
    id: 2,
    name: "Amit Singh",
    company: "Vehicle Owner",
    role: "Fleet Partner",
    content: "Joining Primeswift's network was the best decision. Consistent loads, timely payments, and professional support.",
    rating: 5
  },
  {
    id: 3,
    name: "Priya Sharma",
    company: "",
    role: "Supply Chain Head",
    content: "Outstanding service quality and cost-effective solutions. They handle our nationwide distribution efficiently.",
    rating: 5
  }
];

export const stats = [
  { label: "Fleet Partners", value: "500+", icon: "Truck" },
  { label: "Cities Covered", value: "200+", icon: "MapPin" },
  { label: "Deliveries/Month", value: "10K+", icon: "Package" },
  { label: "Client Satisfaction", value: "98%", icon: "Star" }
];

// Mock form submission handlers
export const submitVehicleRegistration = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Vehicle registration submitted:", formData);
      resolve({
        success: true,
        message: "Thank you for registering! Our team will contact you within 24 hours."
      });
    }, 1000);
  });
};

export const submitQuoteRequest = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Quote request submitted:", formData);
      resolve({
        success: true,
        message: "Your quote request has been received. We'll get back to you shortly."
      });
    }, 1000);
  });
};
